import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionDataSection,
  ReportSectionPlacementType,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';

export class InstitutionHeaderConfiguration extends ReportSectionConfigurationBase {
  typeName = 'InstitutionHeaderConfiguration';
  nodataLocalizationKeyName = 'institutionHeader';
  readonly reportSection = ReportSection.None;
  readonly name = 'institutionHeader';
  readonly displayName = 'Header';
  override readonly placementType = ReportSectionPlacementType.Static;
  readonly applicableReportTypes = [ReportType.Institution];
  readonly reportViewModelSections = [ReportViewModelSection.InvestorProfile_InstitutionBaseInfo];
  minSize = 2;
  maxSize = 4;
  defaultSize = 4;
  readonly availableDataSections: ReportSectionDataSection[] = [
    {
      name: 'institutionHeaderBestFundName',
      displayName: 'Best Fund',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'institutionHeaderSustainabilityLeaf',
      displayName: 'Sustainability Leaf',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'institutionHeaderPrimaryContactName',
      displayName: 'Primary Contact Name',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'institutionHeaderPrimaryContactEmail',
      displayName: 'Primary Contact Email',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'institutionHeaderPrimaryContactPhoneNumber',
      displayName: 'Primary Contact Phone Number',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'institutionHeaderPrimaryContactJobRole',
      displayName: 'Primary Contact Job Role',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'institutionHeaderInstitutionPrimaryAddress',
      displayName: 'Institution Primary Address',
      isSelected: false,
      canConfigure: true
    }
  ];
}

export interface InstitutionHeaderData {
  [ReportViewModelSection.InvestorProfile_InstitutionBaseInfo]: BaseInfo;
}

export interface BaseInfo {
  isSustainable: boolean;
  contactDetailsModel: {
    name: string;
    jobTitle: string;
    contacts: {
      email1: string;
      phone1: string;
    };
  };
  profileId: string;
  name: string;
  bestFundName: string;
  address: BaseAddressInfo;
  // contact job title
  jobTitle: string;
}

export interface BaseAddressInfo {
  address?: string;
  addressCity?: string;
  addressCountry?: string;
}
